import { defineMessages } from 'react-intl';

const scope = 'app.widgets.OvernightStats';

const graphLabels = defineMessages({
    arrivals: {
        id: `${scope}.graph.labels.arrivals`,
        defaultMessage: 'Arrivals',
    },
    inHouse: {
        id: `${scope}.graph.labels.inHouse`,
        defaultMessage: 'In-House',
    },
    departures: {
        id: `${scope}.graph.labels.departures`,
        defaultMessage: 'Departures',
    },
});

const tooltipLabels = defineMessages({
    rooms: {
        id: `${scope}.graph.tooltip.labels.rooms`,
        defaultMessage: 'Rooms',
    },
    adults: {
        id: `${scope}.graph.tooltip.labels.adults`,
        defaultMessage: 'Adults',
    },
    children: {
        id: `${scope}.graph.tooltip.labels.children`,
        defaultMessage: 'Children',
    },
    guaranteed: {
        id: `${scope}.graph.tooltip.labels.guaranteed`,
        description: 'Label for a guaranteed value (rooms, adults or children)',
        defaultMessage: 'Guaranteed: {value}',
    },
    nonGuaranteed: {
        id: `${scope}.graph.tooltip.labels.nonGuaranteed`,
        description: 'Label for a non guaranteed value (rooms, adults or children)',
        defaultMessage: 'Unguaranteed: {value}',
    },
});

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Guest breakdown',
    },
    yAxisLabel: {
        id: `${scope}.graph.yAxis.label`,
        defaultMessage: 'Number of rooms',
    },
    noData: {
        id: `${scope}.noDataMessage`,
        defaultMessage: 'No information available for selected day.',
    },
});

export { graphLabels, tooltipLabels };
